module.exports = __webpack_public_path__ + "static/media/simbolos.6a7a967a.png";